import {
  RecognizeVipCriterion,
  RecognizeVipCursor,
  RecognizeVipPage,
} from "@redotech/redo-recognize-common/vip-profile";
import * as z from "zod";

export const getRecognizeVips = {
  name: "getRecognizeVips" as const,
  input: z.object({
    criterion: RecognizeVipCriterion.nullable(),
    search: z.string().trim(),
    cursor: RecognizeVipCursor.nullable(),
  }),
  output: RecognizeVipPage,
};
